export var formValidationRgx = {
    email: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    limitChars: function (minChars, maxChars) {
        return new RegExp("^.{".concat(minChars, ",").concat(maxChars, "}$"));
    },
    onlyNumbers: /^\d+$/,
    floatNumber: /[+-]?([0-9]*[.])?[0-9]+/,
    validCharsWithLimit: function (limit) {
        return new RegExp("^\\s*([0-9a-zA-Z\\s,\\-()'_@~&?!*=.\u00EB\u00FC\u00E1\u00E9\u00ED\u00F3\u00FA\u00C1\u00C9\u00CD\u00D3\u00DA\u00E4\u00C4\u00E5\u00C5\u00F6\u00D6`]{1,".concat(limit, "})\\s*$"));
    },
    upperCaseWithUnderscore: /^[A-Z]+(?:_[A-Z]+)*$/
};
//# sourceMappingURL=rgx.js.map